import React from 'react';
import { createRoot } from 'react-dom/client';
//@ts-ignore
import App from './App.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Guardar la URL base de la API en localStorage al iniciar la app
if (process.env.REACT_APP_API_URL) {
  localStorage.setItem("urlAxioPP", process.env.REACT_APP_API_URL);
}
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
